export const teamMemberEdit = (state = false, action) => {
  switch (action.type) {
    case "SHOW_TEAM_MEMBER_EDIT_LOAD":
      return true
    case "HIDE_TEAM_MEMBER_EDIT_LOAD":
      return false
    default:
      return state
  }
}
